<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 mt-2 pb-2 bgsecond">

                <div class="row   text-light">

                    <div class="col-md-8">

                        <div class="row ">
                            <h1 class=" mt-1 col-md-4 offset-6">
                                <span v-if="actiontype=='Save'">Add</span>
                                <span v-if="actiontype=='Update'">Update</span>
                                Credit Request </h1>
                        </div>
<!--                        <div class="row">-->
<!--                            <div class="col-md-5">-->

<!--                            </div>-->
<!--                            <div class="col-md-3 ">-->
<!--                                <label for="" class="form-label">Branch </label>-->

<!--                                <v-select-->
<!--                                    v-model="branch_id"-->

<!--                                    class="text-dark"-->
<!--                                    placeholder="Select Branch"-->
<!--                                    :options="branches"-->

<!--                                    label="name"-->
<!--                                    :reduce="option => option.id"-->

<!--                                />-->
<!--                            </div>-->
<!--                            <div class="col-md-3 ">-->
<!--                                <label for="" class="form-label">Month </label>-->
<!--                                <v-select-->
<!--                                    v-model="selectedMonth"-->

<!--                                    class="text-dark"-->
<!--                                    placeholder="Select Month"-->
<!--                                    :options="['January','February','March','April','May','June','July','August','September','October','November','December']"-->


<!--                                />-->

<!--                            </div>-->


<!--                        </div>-->

                        <div class="row mt-3">
                            <div class="col-md-5">

                            </div>
                            <div class="col-md-2 ">
                                <label for="" class="form-label">Customer ID </label>
                                <b-input v-model="customer_id"  list="customer-list-id" autocomplete="off" placeholder="Search name or id"> </b-input>
                                <datalist id="customer-list-id" v-if="customers.length">
                                    <option v-for="customer in customers" :key="customer.id" :value="customer.id"> {{ customer.lastName }}   </option>
                                </datalist>
                            </div>

                            <div class="col-md-2 ">
                                <label for="" class="form-label">Case Ref No. </label>
                                <b-input v-model="case_ref_no"> </b-input>
                            </div>
                            <div class="col-md-2 ">
                                <label for="" class="form-label">Amount </label>
                                <b-input v-model="amount"> </b-input>
                            </div>



                        </div>
                        <div class="row mt-3">
                            <div class="col-md-5">

                            </div>
                            <div class="col-md-3 ">
                                <label for="" class="form-label">Order ref No.</label>
                                <b-input v-model="order_ref_no"> </b-input>
                            </div>

                            <div class="col-md-3 ">
                                <label for="" class="form-label">Credit Request Date </label>
                                <b-form-datepicker
                                    v-model="credit_request_date"
                                    :date-format-options="{ day: 'numeric', month: 'long', year: 'numeric' }"
                                    class="mb-2"
                                    placeholder="Select date">
                                </b-form-datepicker>
                            </div>




                        </div>
                        <div class="row mt-3">
                            <div class="col-md-5">

                            </div>
                            <div class="col-md-6 ">
                                <label for="" class="form-label">Notes.</label>
                                <b-input v-model="notes"> </b-input>
                            </div>






                        </div>




                        <div class="row ">
                            <div class="col-md-4 offset-6">
                                <button  type="button" class="btn custom-btn2 w-100 btn-lg text-light   mt-5 mtmb" @click="save_credit" :disabled="saving ||fetching || (authenticatedUser.permissions.includes('super') && actiontype=='Save')"> <span v-if="actiontype=='Update'" >Update</span>  <span v-if="actiontype=='Save'">Save</span> </button>
                            </div>
                        </div>




                    </div>


                </div>



            </div>

        </div>

    </div>

</template>

<script>
import apiService from "@/service/apiService";
import {mapActions, mapState} from "vuex";
import { mapGetters } from 'vuex';
//import { mapState } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import axios from "axios";
import {cloneDeep} from "lodash";
import Swal from "sweetalert2";
import showrealtime from "@/components/showrealtime";
import URL from "@/constants/baseurl"
import Welcomenote from "@/pages/admin/mypos/welcomenote";
import vSelect from "vue-select";
import moment from "moment";


export default {
    name: "cashierform",

    components:{Welcomenote, 'v-select': vSelect, 'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),
        // ...mapState('invoice', ['cashiers']),
        ...mapState('invoice', ['branches']),


        // ...mapState('invoice', ['branches']),
        // totalPages() {
        //     const itemsPerPage = 10;
        //     return Math.ceil(this.filteredOrders.length / itemsPerPage);
        // },
        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },
        actiontype(){
            if (this.$route.query.type=='add'){
                return 'Save'
            }
            else if (this.$route.query.type=='edit'){
                return 'Update'
            }
            else {
                return 'View'
            }
        }

    },
    data() {
        return {

            customers:[],
            saving:false,
            fetching:false,
            customer_id:'',
            case_ref_no:'',
            order_ref_no:'',
            notes:'',
            credit_request_date:'',
            amount:'',
            status:'',
            min_target:'',
            target:'',
            high_target:'',
            selectedMonth:'',
            branch_id:'',
            roles: [],
            user: {},
            selectedBranches:[],
            branches:[],




        };
    },
    async created() {
        //  await this.getUsers();
        // await this.getRoles();
        await  this.reloadcb()
        // await this.getcashiers()
        this.viewType = this.$route.query.type;
        this.credit_id = this.$route.query.id;
        // console.log("View type:", this.viewType);
        // console.log("Cashier ID:", this.cashier_id);
        this.setCredit()



    },
    async mounted() {


    },

    watch: {



        async customer_id(newVal) {




            await this.getcustomers(newVal);
        },


    },
    methods: {
        ...mapActions(['login', 'processLogoutManual']),
        ...mapActions('invoice', ['getbranches']),


        async getcustomers(name){
            //  alert(name)
            //  console.log(name)
            const apiToken = localStorage.getItem('token');
            if (apiToken) {
                // Set the Authorization header with the API token
                axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
            }
            try {
                const response = await axios.post(`${URL.BASEURL}/api/get_customers`,  {name:name});
                this.customers=response.data

                //   alert(this.found)
                //   console.log(this.cardcustomers,'===================')



            } catch (error) {
                console.error("Error getting customer:", error);
            }

        },

        async reloadcb(){
            if(this.branches.length==0){

                //   alert(this.branches.length)
                await this.getbranches()
                // console.log(this.latestinvoices.data.length,'here')

            }

        },
        async signOut() {
            await this.processLogoutManual();
            // await this.$router.push({ name: "Login" });
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },
        async getUsers(role = '') {
            const { data } = await this.$axios.get(`user?role=${role}`);
            this.items = data;
        },
        async getRoles() {
            const { data } = await this.$axios.get('role');
            this.roles = data.roles;
        },
        filterUsers(value) {
            this.getUsers(value)
        },
        async getbranches(){
            const {data} = await apiService.get(`/branches`);
            console.log('branches', data)
            this.branches=data
        },

        async save_credit() {
            const apiToken = localStorage.getItem('token');
            if (apiToken) {
                // Set the Authorization header with the API token
                axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
            }


            let data={
                customer_id:this.customer_id,
                case_ref_no:this.case_ref_no,
                amount:this.amount,
                order_ref_no:this.order_ref_no,
                credit_request_date:this.credit_request_date,
                notes:this.notes,
                status:'Draft',
            }
            this.saving=true
            try {
                let api_url=`${URL.BASEURL}/api/create-credit-request`
                if(this.credit_id){
                    api_url=`${URL.BASEURL}/api/update-credit-request/${this.credit_id}`
                }
                const response = await axios.post(api_url,  data);

                if(this.credit_id){
                    await Swal.fire('Success', 'Credit Request updated successfully!', 'success');
                } else {
                    await Swal.fire('Success', 'Credit Request created successfully!', 'success');
                }

                this.$router.push({ path: '/credits' })



            } catch (error) {
                console.error("Error saving Credit:", error);
            }
            finally {
                this.saving=false
            }
        },
        formatDate(date){
            let date1 = new Date(date)
            let date2 = moment(date1).format('MMMM');

            return date2;
        },
        async  setCredit(){
            if(this.viewType!=='add'){
                this.fetching=true
                const {data} = await apiService.get(`/get-credit/${this.credit_id}`);

                this.customer_id=data.requested_for_customer_id;
                this.case_ref_no=data.case_ref_no;
                this.order_ref_no=data.order_ref_no;
                this.notes=data.notes;
                this.credit_request_date=data.credit_request_date;
                this.amount=data.amount;
                this.status=data.status;

                this.fetching=false

            }
        },
    }
};
</script>



<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}



</style>
